<template>
    <v-toolbar color="transparent" elevation="0" class="kp-sublime-toolbar" :height="calcHeight">
        <slot></slot>
    </v-toolbar>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
    defineProps<{
        height?: string | number | null;
        dense?: boolean;
    }>(),
    {
        height: null,
        dense: false,
    },
);

const calcHeight = computed(() => {
    if (props.height) {
        return props.height;
    }
    if (props.dense) {
        return '36px';
    }
    return '48px';
});
</script>
